import React, { useEffect, useState } from 'react';
import { analyticsUserTrack } from "../config/analyticsTrack";
import "./GHT.css"
import Logo from './assets/logo.png'
import resources from './assets/resources/resources.pdf'
import res1 from './assets/resources/res1_full.jpg'
import slide1 from './assets/resources/slide/1.png'
import slide2 from './assets/resources/slide/2.png'
import slide3 from './assets/resources/slide/3.png'
import slide4 from './assets/resources/slide/4.png'
import slide5 from './assets/resources/slide/5.png'
import slide6 from './assets/resources/slide/6.png'
import slide7 from './assets/resources/slide/7.png'
import slide8 from './assets/resources/slide/8.png'
import Config from '../helper/Config';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Header from './components/Header';
import Footer from './Footer';
import Modal from '../components/Modal';
import i3_1 from './assets/3_1_new.png'
import i3_2 from './assets/3_2_v1.jpg'

export default function GhtResources(props) {
    const [showMenu, setShowMenu] = useState(false);
    const [active, setActive] = useState(null);

    useEffect(() => {
        analyticsUserTrack("GHT - GHT Resources", "Landing");
        window.scrollTo(0, 0);
    }, [])

    function viewModalData() {
        let returnText = ""
        switch (active) {
            case "PDF":
                returnText = <img className='img-fluid' src={res1} />
                break;
            default:
                let images=[
                    slide1,
                    slide2,
                    slide3,
                    slide4,
                    slide5,
                    slide6,
                    slide7,
                    slide8
                ];
                
                returnText = <img className='img-fluid' src={images[active]} />

                break;
        }
        return returnText

    }

    const openPDF = () => {
        window.open(resources, '_blank');
    };

    return <div className='version-2 GHT nairobi-june'>
        <div className='block1' style={{ marginTop: 0 }}>
            <div className={`home-sticky-crop home`} style={{ top: 0 }}>
                <Link to={Config.projectUrl + "/GHT"} onClick={() => window.scrollTo(0, 0)}>
                    <img className='logo' src={Logo} />
                </Link>
                <Header page="social-impact" />
            </div>
        </div>

        <div className='container py-5'>
            <div className='d-flex justify-content-center heading-text text-center' >
                <div className={`montserrat-font-family fw-bold`}>GHT Resources</div>
            </div>
            <div className='d-flex'>
                <div className='flex-1 cursor-pointer' onClick={() => {
                    openPDF()
                    analyticsUserTrack("GHT - GHT Resources", "Clicked - PDF");
                }}>
                    <img className='img-fluid' src={res1} />
                </div>
                <div className='flex-1 mx-5 d-flex flex-column' style={{ justifyContent: "space-between"}}>
                    <div className='d-flex'>
                        <div className='flex-1 mx-2 cursor-pointer' onClick={() => {
                            analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                            setActive(0)
                        }}>
                            <img className='img-fluid' src={slide1} />
                        </div>
                        <div className='flex-1 mx-2 cursor-pointer' onClick={() => {
                            analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                            setActive(1)
                        }}>
                            <img className='img-fluid' src={slide2} />
                        </div>
                    </div>
                    <div className='d-flex '>
                        <div className='flex-1 mx-2 cursor-pointer' onClick={() => {
                            analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                            setActive(2)
                        }}>
                            <img className='img-fluid' src={slide3} />
                        </div>
                        <div className='flex-1 mx-2 cursor-pointer' onClick={() => {
                            analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                            setActive(3)
                        }}>
                            <img className='img-fluid' src={slide4} />
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='flex-1 mx-2 cursor-pointer' onClick={() => {
                            analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                            setActive(4)
                        }}>
                            <img className='img-fluid' src={slide5} />
                        </div>
                        <div className='flex-1 mx-2 cursor-pointer' onClick={() => {
                            analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                            setActive(5)
                        }}>
                            <img className='img-fluid' src={slide6} />
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className='flex-1 mx-2 cursor-pointer' onClick={() => {
                            analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                            setActive(6)
                        }}>
                            <img className='img-fluid' src={slide7} />
                        </div>
                        <div className='flex-1 mx-2 cursor-pointer' onClick={() => {
                            analyticsUserTrack("GHT - GHT Resources", "Clicked - Slide");
                            setActive(7)
                        }}>
                            <img className='img-fluid' src={slide8} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='ght-3'>
                <div className='mt-5 text-center'>
                    <img className='img-fluid' src={i3_1}></img>
                    <div className='fs-sm text-center'>World map in which territory size demonstrates the relative number of physicians working in that territory. (Creative commons <br/> licence © sasi group (University of Sheffield) and M. Newman (University of Michigan, www.worldmapper.org))</div>
                </div>
                <div className='mt-5 text-center'>
                    <div style={{ position: "relative", display: "inline-block"}}>
                        <img className='img-fluid' src={i3_2}></img>
                        <div className='fs-sm' style={{ position: "absolute", right: 10, bottom: 5}}>Journal of Neurosurgery, January 2024</div>
                    </div>
                </div>
            </div>
        </div>
        {
            active !== null && <Modal
                visible={active !== null ? true : false}
                closeModal={() => {
                    setActive(null)
                }}
                heading={""}
                size={"modal-xl"}
                parentClass={"ght-resources-modal"}
                body={<React.Fragment>
                    <div style={{ position: "relative"}}>
                        <div className='modal-close-custom cursor-pointer' onClick={() => setActive(null)}>
                            <i className='fa fa-minus' />
                        </div>
                        <div className='ght-resources-content'>
                            {viewModalData()}
                        </div>
                    </div>
                </React.Fragment>
                }
                
            />
        }
        <Footer />
    </div>
}
